import { MultiChoiceArticlePage } from '../../model/components/PollArticlePage';
import { isMultiChoicePost } from '../../model/PostTypes';
import { MultiChoicePostData } from '../../model/types/MultiChoicePostData';
import { PathContextProvider } from '../../PathContext';
import { usePortalPostEditor } from '../../Post';
import { PollMultiChoiceInput } from './PollMultiChoiceInput';

import { assert } from '../../../utils/assert';

import styles from './VoteSliderPostInput.module.scss';

export interface MultiChoicePostInputProps {
    value: MultiChoicePostData;
    onChange?: (value: MultiChoicePostData) => void;
}

export const MultiChoicePostInput = ({
    value,
    onChange,
}: MultiChoicePostInputProps) => {
    const { post } = usePortalPostEditor();
    assert(
        isMultiChoicePost(post),
        'MultiChoicePostInput must be rendered with a MultiChoice post',
    );
    const [frontPage] = value.pages;
    const onFrontPageChange = (page: MultiChoiceArticlePage) => {
        onChange?.({
            ...value,
            pages: [page],
        });
    };

    return (
        <div>
            <div className={styles.container}>
                <fieldset>
                    <legend>Poll</legend>
                    {frontPage.poll && (
                        <PathContextProvider segment="pages">
                            <PathContextProvider segment={0}>
                                <PathContextProvider segment="poll">
                                    <PollMultiChoiceInput
                                        value={frontPage.poll}
                                        onChange={(poll) =>
                                            onFrontPageChange({
                                                ...frontPage,
                                                poll: poll,
                                            })
                                        }
                                    />
                                </PathContextProvider>
                            </PathContextProvider>
                        </PathContextProvider>
                    )}
                </fieldset>
            </div>
        </div>
    );
};
